import { code } from "@spscommerce/utils";

export const SpsPageTitleExamples = {
    basic: {
        label: "Basic",
        examples: [{
            template: code`
                <sps-page-title>
                    Cabela's Purchase Order #123456789012
                </sps-page-title>`
        }]
    },
    withIcon: {
        label: "With Icon",
        examples: [{
            template: code`
                <sps-page-title>
                    <i spsIcon="status-in-transit" aria-hidden="true" title="In Transit"></i>
                    Cabela's Purchase Order #123456789012
                </sps-page-title>`
        }]
    },
    withSubTitle: {
        label: "With Subtitle",
        examples: [{
            template: code`
                <sps-page-title>
                    Cabela's Purchase Order #123456789012
                    <sps-page-subtitle>
                        Cabela's <i spsIcon="outgoing"></i> MacNeil Automotive Parts
                    </sps-page-subtitle>
                </sps-page-title>
            `
        }]
    },
    withSubtitleAndIcon: {
        label: "With Subtitle and Icon",
        examples:
        [{
            template: code`
                <sps-page-title>
                    <i spsIcon="status-in-transit" aria-hidden="true" title="In Transit"></i>
                    Cabela's Purchase Order #123456789012
                    <sps-page-subtitle>
                        Cabela's <i spsIcon="outgoing"></i> MacNeil Automotive Parts
                    </sps-page-subtitle>
                </sps-page-title>
            `
        }]
    }
};
